<template>
  <div class="podcast_iframe">
    <iframe id="sc-widget" ref="anchorIframe" :src="this.podcastUrl" height="170" max-height="100%" width="100%" frameborder="0" scrolling="no"></iframe>
  </div>
</template>:

<script>
import PodcastManager from '@/lib/podcast'

export default {
  name: 'Anchor',
  data() {
    return {
      frame: null,
      trackId: null,
      anchorEmbeddedUrl: null,
    }
  },
  props: {
    url: {
      type: String,
      required: true,
    }
  },
  computed: {
    podcastUrl() {
      return this.anchorEmbeddedUrl
    },
  },
  async mounted() {

    const anchorEnv = await PodcastManager.getAnchorEnvironment(this.url)
    const anchorEp = await PodcastManager.getAnchorEpisode(this.url)

    const anchorEpId = anchorEp.split('-').pop()

    this.anchorEmbeddedUrl = `https://anchor.fm/${anchorEnv}/embed/episodes/${anchorEp}`

    let anchorTrackUrl = `https://vinovibes-cors-anywhere.herokuapp.com/https://anchor.fm/api/v3/episodes/${anchorEpId}`
    // if (process.env.VUE_APP_ENV == 'development')
    //   anchorTrackUrl = `https://vinovibes-cors-anywhere.herokuapp.com/https://anchor.fm/api/v3/episodes/${anchorEpId}`
    // else anchorTrackUrl = `https://anchor.fm/api/v3/episodes/${anchorEpId}`

    this.$emit('propagate-offline-download', {id: anchorEp, url: anchorTrackUrl});
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.podcast_iframe {
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
}

#sc-widget {
  max-width: 865.77px;
}
</style>
